<!-- 题库建设 -->
<template>
    <div class="question-bank-build">
        <div class="question-bank-build-top">
            <div class="title">题库建设</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="question-bank-build-number">
            <div class="question-bank-build-number-item" v-for="item,index in numberList" :key="index">
                <div class="name">{{ item.name }}</div>
                <div class="number">{{ item.number }}</div>
            </div>
        </div>
        <div class="question-bank-build-progress">
            <div class="rank-li" v-for="item,index in rankList" :key="item.id">
                <div class="rank">NO.{{index+1}}</div>
                <div class="subject-name">{{ item.schoolName }}</div>
                <div class="rate">
                    <el-progress class="rank-progress" :color="'#2B7FFF'" :duration="3" :intermediate="true" :show-text="false" :percentage="item.progress" :stroke-width="16"></el-progress>
                    <div class="number">{{ item.number }}</div>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
import { getQuesStatAPI,getUseQueListAPI } from "@/service/api.js"
  export default {
    name: 'question-bank-build',
    components: {
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            numberList:[
                {
                    name:'题目数',
                    number:20751
                },
                {
                    name:'专题数',
                    number:43
                },
                {
                    name:'教研人员',
                    number:246
                }
            ],
            rankList:[
                {
                    id:'1',
                    schoolName:'初中英语',
                    number:1369,
                    progress:100
                },
                {
                    id:'2',
                    schoolName:'初中语文',
                    number:1325,
                    progress:95
                },
                {
                    id:'3',
                    schoolName:'初中数学',
                    number:1300,
                    progress:91
                },
                {
                    id:'4',
                    schoolName:'初中物理',
                    number:1269,
                    progress:88
                },
                {
                    id:'5',
                    schoolName:'初中化学',
                    number:1254,
                    progress:86
                },
                {
                    id:'6',
                    schoolName:'初中生物',
                    number:1236,
                    progress:82
                }
            ]
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.getQuesStat();
            }
        }
    },
    methods: {
        
    },
    mounted(){
        
    },
  }
</script>
  
<style lang="scss" scoped>
.question-bank-build{
    width: 100%;
    height: 350px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .question-bank-build-top{
        position: relative;
        text-align: center;
        margin-bottom: 13px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .question-bank-build-number{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 15px;
        .question-bank-build-number-item{
            display: flex;
            align-items: center;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .question-bank-build-progress{
        .rank-li{
            width: 100%;
            height: 28px;
            display: flex;
            align-items: center;
            margin-bottom: 14px;
            .rank{
                // font-size: 14px;
                // font-family: DingTalk JinBuTi;
                // font-weight: 400;
                // color: #6EA0D3;;
                // display: inline-block;
                // width: 60px;
                // padding: 8px 10px;
                // text-align: left;
                font-size: 14px;
                font-family: DingTalk JinBuTi;
                font-weight: 400;
                color: #6EA0D3;
                display: inline-flex;
                width: 60px;
                align-items: center;
                justify-content: center;
                height: 28px;
                text-align: left;
                background-size: 100% 100%;
                background: url('../../../assets/images/sydataboard/four.png') no-repeat;
            }
            .subject-name{
                width: 80px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
            }
            .rate{
                width: calc(100% - 140px);
                display: flex;
                align-items: center;
                .rank-progress{
                    width: calc(100% - 80px);
                }
                .number{
                    margin-left: 10px;
                    display: inline-block;
                    width: 70px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                    text-align: left;
                }
            }
        }
        .rank-li:last-child{
            margin-bottom: 0;
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
.question-bank-build{
    .question-bank-build-progress{
        .rank-li{
            .rate{
                .el-progress-bar{
                    .el-progress-bar__outer{
                        background-color: transparent;
                        border-radius: 0;
                        .el-progress-bar__inner{
                            border-radius: 0;
                        }
                    }
                    .el-progress__text{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #6EA0D3;
                    }
                }
            }
        }
    }
}
</style>